<script setup lang="ts">
import {
  Card,
  CardAspect,
  CardMedia,
  CardMediaChip,
  CardSubtitle,
  CardTitle,
  IconName,
  Icon,
} from '@exfluential/ui';
import { UserDashboardHubDto } from '~/api/dashboard';
import { useSearchResultUrl } from '~/composables/use-search-result-url';

type Props = {
  hub: UserDashboardHubDto;
};

defineProps<Props>();

const { createHubUrl } = useSearchResultUrl();
</script>

<template>
  <Card interactive data-testid="hub-card">
    <CardMedia
      :src="hub.logoUrl"
      :to="createHubUrl(hub.slug)"
      :alt="$t('hub.alt')"
      :aspect="CardAspect.CIRCLE"
      :fallback-icon-name="IconName.FILE_IMAGE"
    >
      <template #top-left>
        <CardMediaChip :label="$t('common.hubs')">
          <Icon :name="IconName.AWARD" class="size-[1rem]" />
        </CardMediaChip>
      </template>
    </CardMedia>

    <hr class="w-full border-line" />

    <CardTitle :title="hub.title" :to="createHubUrl(hub.slug)" />

    <CardSubtitle
      :text="`${hub.contentsCount} ${$t('common.content-items')}`"
    />
  </Card>
</template>
